import { useCallback } from "react";
import TrashLineIcon from "remixicon-react/DeleteBin2LineIcon";
import useCompany from "$hooks/useCompany";
import { getActivitiesOptions } from "$utils/typeConstants";
import { useActivitiesQuery } from "$hooks/useActivitiesQuery";
import UserForm from "../../../Coordinators/UserForm";
import useUserForm from "$hooks/useUserForm";
import useAuth from "$hooks/useAuth";
import { DeleteUser } from "$services/Coordinators.service";
import { FormHeader } from "$components/Forms/FormHeader";
import { useModal } from "$components/JModal/useModal";

interface ContactFormModalProps {
  user: any;
  title: string;
  id: string;
  companyTypes: any[];
  togglePopin: (isOpen?: boolean) => void;
  company: any;
  onUserSaved?: (savedUser: any) => void;
}

export default function ContactFormModal({
  user,
  title,
  id,
  companyTypes,
  togglePopin,
  company,
  onUserSaved,
}: ContactFormModalProps) {
  const token = localStorage.getItem("access_token");
  const { JModal, openModal, setOpenModal, isOpenModal } = useModal();
  const { isAgency, isContributor, isClient } = useCompany();
  const { data: activities = [] } = useActivitiesQuery();

  const companyActivities = activities?.filter((a) =>
    company?.activities?.some((a2) => a2._id === a._id)
  );

  const { isAdmin } = useAuth();

  const { onSubmit, onSubmitEdit, error: errorUser } = useUserForm(id);

  const handleDeleteUser = useCallback(async () => {
    await DeleteUser(token, user?._id);
    setOpenModal(false);
    togglePopin();
  }, [setOpenModal, togglePopin, token, user?._id]);

  const handleSubmit = async (arg: any) => {
    const res = user ? await onSubmitEdit(arg) : await onSubmit(arg);
    if (res && !res?.error) {
      onUserSaved?.(res);
    }
    togglePopin();
  };

  return (
    <>
      <FormHeader
        title={title}
        icon={user && isAdmin() ? <TrashLineIcon /> : undefined}
        onClick={openModal}
      />
      <UserForm
        user={user}
        onSubmit={handleSubmit}
        onReset={togglePopin}
        isCoordinator={false}
        canHaveTwoPhones={isAgency(companyTypes)}
        canBeUser={isClient(companyTypes) || isContributor(companyTypes)}
        error={errorUser}
        activitiesOptions={
          isAgency(companyTypes) ? getActivitiesOptions(companyActivities) : []
        }
      />
      {isOpenModal && (
        <JModal
          message={`Êtes vous sur de vouloir supprimer l'utilisateur : ${user?.lastname} ${user?.firstname} (${user?.email})`}
          labelOk="Supprimer"
          labelCancel="Annuler"
          onConfirm={handleDeleteUser}
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
}
